import { cn } from '@/lib/utils'
import type { PageType } from '@/modules/common/consts'
import type { PropsWithChildren, ReactNode } from 'react'
import { ModuleHeader } from './module-header'

interface Props extends PropsWithChildren {
  className?: string

  title: ReactNode
  page?: PageType
  loading?: boolean

  headerActions?: ReactNode
  headerActionsClassName?: string
  headerRight?: ReactNode
  headerRightClassName?: string
}

export function ModuleWrapper({
  children,
  className,

  title,
  page,
  loading = false,

  headerActions,
  headerActionsClassName,
  headerRight,
  headerRightClassName,
}: Props) {
  return (
    <div className={cn('p-4', 'md:px-13 md:pt-8 md:pb-13', className)}>
      <ModuleHeader
        title={
          !headerActions ? (
            title
          ) : (
            <div>
              <div>{title}</div>
              <div className={cn('mt-2', headerActionsClassName)}>
                {headerActions}
              </div>
            </div>
          )
        }
        page={page}
        loading={loading}
        contentClassName={headerRightClassName}
      >
        {headerRight}
      </ModuleHeader>

      {children}
    </div>
  )
}
